<script>
import { notificationMethods } from '@/state/helpers';
import Loading from 'vue-loading-overlay';

export default {
  name: 'app',
  page: {
    title: 'Inventory',
    // All subcomponent titles will be injected into this template.
    titleTemplate(title) {
      title = typeof title === 'function' ? title(this.$store) : title;
      let translated = this.$t('titles.' + title);
      return translated ? `${translated}` : 'Inventory';
    },
  },
  components: {
    Loading,
  },
  data() {
    return {
      fullPageLoading: false,
      opacity: 0,
      lang: this.$i18n.locale,
    };
  },
  watch: {
    /**
     * Clear the alert message on route change
     */
    // eslint-disable-next-line no-unused-vars
    $route(to, from) {
      // clear alert on location change
      this.clearNotification();
    },
  },
  methods: {
    clearNotification: notificationMethods.clear,
  },
  computed: {
    isLoadingConfig() {
      return this.$store.state.user.loadingUserConfig;
    },
  },
};
</script>

<template>
  <div id="app">
    <div
      v-if="isLoadingConfig"
      id="initLoadingOverlay"
      style="
        flex-direction: column;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: rgb(255, 255, 255);
        z-index: 9999;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
      "
    >
      <loading
        :active.sync="isLoadingConfig"
        :can-cancel="false"
        color="#f1b44c"
        :width="60"
        :opacity="opacity"
        :height="60"
        loader="dots"
        :is-full-page="fullPageLoading"
      ></loading>

      <p class="text-muted mt-0">Loading...</p>
    </div>

    <RouterView />
  </div>
</template>
